import { gql } from '../../../../types/__codegen__/sanity';

export const GET_OFFER_TERMS = gql(`
  query getOfferTerms($id: String) {
    allOffer(where: { identifier: { current: { eq: $id } } }) {
      canBeRedeemedWithPromoCode {
        code {
          current
        }
        codeType
      }
      minimumGapInCoverDays
      id: _id
      _createdAt
      targetsSegments {
        identifier {
          current
        }
      }
      offerTypes {
        ...OfferTypesFields
      }
      release {
        ...ReleaseFields
      }
    }
  }
`);
